/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { SocialShare } from '../../../components/FBSocial';
import Iconify from '../../../components/Iconify';
import Markdown from '../../../components/Markdown';
import useAuth from '../../../hooks/useAuth';
import useLocales from '../../../hooks/useLocales';
import { useSelector } from '../../../redux/store';
import { createBookmarkAPI, deleteBookmarkAPI, getBookmarkAPI } from '../../../service/blog/blog.bookmark.service';
import { getStatisticAPI, updateLikeAPI, updateViewAPI } from '../../../service/blog/blog.statistic.service';
import { fShortenNumber } from '../../../utils/formatNumber';
import CommentList from '../../comment/CommentList';
import CommentNewForm from '../../comment/CommentNewForm';
import BlogPostTags from './BlogPostTags';

export function PostDescription() {
  const { enqueueSnackbar } = useSnackbar();
  const { isAuthenticated } = useAuth();
  const { translate } = useLocales();

  const { post } = useSelector((state) => state.blogPost);

  const [statistic, setStatistic] = useState({ viewNo: 0, likeNo: 0, commentNo: 0 });

  const [bookmark, setBookmark] = useState(null);
  useEffect(() => {
    const timeout = setTimeout(() => {
      updateView();
      getStatistic();
    }, 500);
    return () => clearTimeout(timeout);
  }, [post?.id]);

  const updateView = async () => {
    updateViewAPI(post?.statistic.id);
  };

  const handleLike = async () => {
    if (!isAuthenticated) {
      enqueueSnackbar(translate('label.signinToJmaster'), { variant: 'error' });
      return;
    }
    const { code } = await updateLikeAPI(post?.statistic.id);
    code === '200' && getStatistic();
  };

  const getStatistic = async () => {
    const { code, data } = await getStatisticAPI(post?.statistic.id);
    code === '200' && setStatistic(data);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      isAuthenticated && isBookmarked();
    }, 500);
    return () => clearTimeout(timeout);
  }, [post, isAuthenticated]);

  const isBookmarked = async () => {
    const { code, data } = await getBookmarkAPI(post?.id);
    if (code === '200') setBookmark(data);
    else setBookmark(null);
  };

  const handleBookmark = async () => {
    if (!isAuthenticated) {
      enqueueSnackbar(translate('label.signinToJmaster'), { variant: 'error' });
      return;
    }

    if (bookmark) {
      let { code } = await deleteBookmarkAPI(bookmark.id);

      if (code === '200') {
        setBookmark(null);
        enqueueSnackbar(translate('message.bookmarkCancel'));
      }
    } else {
      const request = {
        post: { id: post?.id },
      };
      let { code, data } = await createBookmarkAPI(request);

      if (code === '200') {
        setBookmark(data);
        enqueueSnackbar(translate('message.bookmarkSuccess'));
      }
    }
  };

  return (
    <Stack spacing={1}>
      <Stack direction={'row'} spacing={1} justifyContent={'space-between'}>
        <Typography variant="h6">
          {post?.title}
        </Typography>
        <IconButton size="small" color="default" onClick={handleBookmark}>
          <Iconify
            icon={bookmark ? 'material-symbols:bookmark' : 'material-symbols:bookmark-outline'}
            width={18}
            height={18}
          />
        </IconButton>
      </Stack>
      <Stack direction={'row'} spacing={2} alignItems={'center'}>
        <SocialShare title={post?.title} />
        <Stack direction={'row'} alignItems={'center'} spacing={0.8}>
          <Typography variant="caption">{fShortenNumber(statistic.viewNo)}</Typography>
          <Iconify icon={'mdi:eye-outline'} sx={{ height: 15, width: 15 }} />
        </Stack>
      </Stack>
      <Divider sx={{ my: 1 }} />
      <div className="ql-snow">
        <div className="ql-editor" style={{ padding: 0 }}>
          <Markdown children={post?.description} />
        </div>
      </div>
      <Box sx={{ my: 1 }}>
        <Divider />
        <BlogPostTags tags={post?.tags} statistic={statistic} handleLike={handleLike} />
        <Divider />
      </Box>
      <Box sx={{ display: 'flex', mb: 2 }}>
        <Typography variant="h4">{translate("button.comment")}</Typography>
        <Typography variant="subtitle2" sx={{ color: 'text.disabled' }}>
          ({statistic?.commentNo})
        </Typography>
      </Box>
      <CommentNewForm itemId={post?.id} type="POST" />
      <CommentList />
    </Stack>
  );
}
